import React from 'react'
import { Switch, Redirect } from 'react-router-dom'

import {
  RouteLayout as MainRoute,
  MinimalLayout as MinimalRoute
} from './components'
import {
  Auth as AuthLayout,
  Guest as GuestLayout,
  Minimal as MinimalLayout
} from './layouts'

import { connect } from 'react-redux'

import {
  Home as HomeView,
  Category as CategoryView,
  Product as ProductView,
  ProductLanding as ProductLandingView,
  Cart as CartView,
  Register as RegisterView,
  ChangePassword as ChangePasswordView,
  Policy as PolicyView,
  History as HistoryView,
  HistoryDetail as HistoryDetailView,
  Commission as CommissionView,
  TransactionPublicDetail as TransactionPublicDetailView
} from './views'

const Routes = ({ authenticate }) => {
  return (
    <Switch>
      <MainRoute
        isAuthenticated={authenticate.status}
        component={HomeView}
        exact
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={CategoryView}
        exact
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/kategori/:id"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={ProductView}
        exact
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/produk/:id"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={CartView}
        exact
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/keranjang"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={HistoryDetailView}
        exact
        requireAuth
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/transaksi/detail/:code"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={HistoryDetailView}
        exact
        requireAuth
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/transaksi/:code"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={HistoryView}
        exact
        requireAuth
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/transaksi"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={CommissionView}
        exact
        requireAuth
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/komisi"
      />
      <MinimalRoute
        component={RegisterView}
        exact
        minimalLayout={MinimalLayout}
        path="/daftar-agen"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={ChangePasswordView}
        exact
        requireAuth
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/ganti-password"
      />
      <MainRoute
        isAuthenticated={authenticate.status}
        component={HomeView}
        exact
        authLayout={AuthLayout}
        guestLayout={GuestLayout}
        path="/auth"
      />
      <MinimalRoute
        component={ProductLandingView}
        exact
        minimalLayout={MinimalLayout}
        path="/landing/produk/:id"
      />
      <MinimalRoute
        component={PolicyView}
        exact
        minimalLayout={MinimalLayout}
        path="/policy"
      />
      <MinimalRoute
        component={TransactionPublicDetailView}
        exact
        minimalLayout={MinimalLayout}
        path="/pembelian/:code"
      />
      <MinimalRoute
        component={TransactionPublicDetailView}
        exact
        minimalLayout={MinimalLayout}
        path="/landing/transaksi/:code"
      />
      <Redirect to="/not-found" />
    </Switch>
  )
}

const mapStateToProps = (state) => {
  return {
    authenticate: {
      status: state.auth.authenticate.status
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes)